// Titlebar — sits above the body grid. macOS uses an Overlay traffic-light
// style (configured in tauri.conf.json), so we leave room for the native dots
// and provide our own drag region across the rest of the bar.
//
// Brand: the Bvndle wordmark sits left, followed by a small "COMMAND CENTRE"
// sub-mark. Clicking the brand re-opens the splash (handled by Shell).
// Status pills read from useHealth(); the avatar shows the signed-in
// reviewer's initials and clicking it signs out.

import logoUrl from "../assets/bvndle-wordmark@2x.png";
import { useHealth } from "../lib/hooks";
import { useAuth } from "./AuthGate";

function isTauri(): boolean {
  return typeof window !== "undefined" && "__TAURI_INTERNALS__" in window;
}

interface Props {
  onBrandClick: () => void;
}

function initials(email: string): string {
  const name = email.split("@")[0] ?? email;
  const parts = name.split(/[.\-_]/).filter(Boolean);
  const a = parts[0]?.[0] ?? name[0] ?? "?";
  const b = parts[1]?.[0] ?? "";
  return (a + b).toUpperCase();
}

export function Titlebar({ onBrandClick }: Props) {
  const health = useHealth();
  const { session, signOut } = useAuth();

  const invariantOk = health?.invariant_holds ?? true;

  return (
    <div className="titlebar">
      <button
        className="titlebar__brand"
        onClick={onBrandClick}
        type="button"
        title="Bvndle Command Centre · click for launcher"
      >
        <img src={logoUrl} alt="Bvndle" />
        <span className="titlebar__brand-sub">COMMAND CENTRE</span>
      </button>
      <div className="titlebar__status">
        <span className="pill pill--env">
          <span className="pill__dot" />
          BVNDLE · COIN ECONOMY
        </span>
        {!isTauri() && (
          <span
            className="pill pill--warn"
            title="Web build — some features (email send, native saves, codebase scan) only work in the desktop app."
            style={{ background: "rgba(217,156,58,0.18)", color: "#d99c3a" }}
          >
            WEB BUILD
          </span>
        )}
        <span className={invariantOk ? "pill pill--ok" : "pill pill--warn"}>
          {invariantOk ? "LEDGER OK" : "LEDGER WATCH"}
        </span>
        {session && (
          <button
            className="avatar"
            type="button"
            onClick={signOut}
            title={`${session.email} · click to sign out`}
            style={{ cursor: "pointer", border: "none" }}
          >
            {initials(session.email)}
          </button>
        )}
      </div>
    </div>
  );
}
